module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main